import { useEffect, useCallback, useState } from 'react';
import { TextField } from '@mui/material';

interface EditableTextFieldProps {
  initialValue: string;
  onUpdate: (val: number) => void;
  type: 'int' | 'float' | 'string' | 'money' | 'percent';
}

export const EditableTextField = ({ initialValue, onUpdate, type }: EditableTextFieldProps) => {
  const [val, setVal] = useState(() => {
    switch (type) {
      case 'percent':
        return (parseFloat(initialValue) * 100).toFixed(2) + '%';
      case 'money':
        return '$' + initialValue;
      case 'int':
      case 'string':
      case 'float':
      default:
        return initialValue.toString();
    }
  });
  useEffect(() => {
    switch (type) {
      case 'percent':
        setVal((parseFloat(initialValue) * 100).toFixed(2) + '%');
        break;
      case 'money':
        setVal('$' + initialValue);
        break;
      case 'int':
      case 'string':
      case 'float':
      default:
        setVal(initialValue.toString());
        break;
    }
  }, [initialValue, type]);

  const onBlur = useCallback(() => {
    let tempVal: any;
    switch (type) {
      case 'int':
        tempVal = parseInt(val);
        if (typeof tempVal !== 'number' || isNaN(tempVal)) {
          tempVal = 0;
          setVal('0');
        }
        setVal(tempVal.toString());
        break;
      case 'float':
        tempVal = parseFloat(val);
        if (typeof tempVal !== 'number' || isNaN(tempVal)) {
          tempVal = 0;
          setVal('0');
        }
        setVal(tempVal.toString());
        break;
      case 'money':
        tempVal = parseFloat(val);
        if (typeof tempVal !== 'number' || isNaN(tempVal)) {
          tempVal = 0;
          setVal('$0');
        }
        setVal(`$${tempVal}`);
        break;
      case 'percent':
        tempVal = parseFloat(val);
        if (typeof tempVal !== 'number' || isNaN(tempVal)) {
          tempVal = 0;
          setVal('0%');
        }
        setVal(`${tempVal}%`);
        break;
      case 'string':
      default:
        tempVal = val;
    }

    onUpdate(tempVal);
  }, [val, setVal, onUpdate, type]);

  return (
    <TextField
      autoFocus={val === ''}
      variant='outlined'
      style={{ maxWidth: 100, minWidth: 85 }}
      value={val}
      onChange={e => setVal(e.target.value)}
      onBlur={onBlur}
    />
  );
};
